// extracted by mini-css-extract-plugin
module.exports = {"outer":"_2DO8E","outerImage":"_2CKxy","contentWrap":"_38t9O","heading":"_2ETtp","ratingText":"_3nEMU","ratingImage":"_2V27w","content":"_2Fjm5"};